import { popEmeraldModal } from '../../common/emerald-modal-manager/emerald-modal-manager';
import CashierPreferencesHelper from '../../common/helpers/cashier-preferences-helper';
import { CashierPreferences } from '../../common/interfaces/dtos/CashierPreferences';
import { store } from '../../common/redux/configure-store';
import {
  CashierPreferencesProps,
  showPreferencesView,
} from '../components/cashier-preferences-view';

export const showCashierPreferencesView = (): void => {
  const userPreferences = store.getState().cashierPreferences;
  const cashierPreferencesProps: CashierPreferencesProps = {
    userPreferences,
    onCancel,
    onSubmit,
  };

  showPreferencesView(cashierPreferencesProps);
};

const onCancel = (): void => {
  popEmeraldModal();
};

const onSubmit = (userPreferences: CashierPreferences): void => {
  popEmeraldModal();
  CashierPreferencesHelper.setUserPreferences(userPreferences);
};
